import { render, staticRenderFns } from "./ScaleSummerWinter.vue?vue&type=template&id=035f1a86&scoped=true&"
import script from "./ScaleSummerWinter.vue?vue&type=script&lang=js&"
export * from "./ScaleSummerWinter.vue?vue&type=script&lang=js&"
import style0 from "./ScaleSummerWinter.vue?vue&type=style&index=0&id=035f1a86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f1a86",
  null
  
)

export default component.exports